export const API_BASE_URL = 'https://demostracion.ayuda.colpegasus.org/php';

export const PLATAFORMAS = {
    WEB: 1,
    MOVIL: 2,
} as const;

export type PlataformaId = typeof PLATAFORMAS[keyof typeof PLATAFORMAS];

export const PLATAFORMA_LABELS: Record<PlataformaId, string> = {
    [PLATAFORMAS.WEB]: 'Academica Web',
    [PLATAFORMAS.MOVIL]: 'App Móvil',
};
